import React from 'react'

const ListFilter =({text, onClick})=>{
    return(
        <span className="text-azul text-center  px-5 py-2 d-block font-15 list-filter w-100" onClick={onClick}>{text}</span>
    )
}


export default ListFilter;